// imports
import Component from 'minsky-kit/js/components/Component';

// private statics

// class definition
export default class TicketSaleStart extends Component {
    // constructor
    constructor (args = {}, objectName = 'TicketSaleStart') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // properties
        this._$startSale = this.$el.getAttribute('data-start-sale');

        if (this._$startSale !== null) {
            // set message
            setMessage.call(this);
        }
    }

    // methods
    refresh () {
        if (this._$startSale !== null) {
            setMessage.call(this);
        }
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
    get needsMessage () {
        // get todays date
        const now = Date.now();
        const saleDate = parseInt(this._$startSale * 1000);

        if(now <= saleDate) {
            return true;
        }
        else {
            return false;
        }
    }
}

function setMessage () {
    if(this.needsMessage){
        this.$el.querySelector('.sale-start').style.display = 'block';
        this.$el.querySelector('.timetable').style.display = 'none';
    }
    else {
        this.$el.querySelector('.sale-start').style.display = 'none';
        this.$el.querySelector('.timetable').style.display = 'block';
    };
}
